const STORAGE_KEY = 'wyz.checkout.firstSearchAt';

export function markFirstSearchIfAbsent(): void {
  if (sessionStorage.getItem(STORAGE_KEY)) return;
  sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
}

export function readCheckoutDurationMs(): number | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  const start = Number.parseInt(raw, 10);
  if (!Number.isFinite(start)) return null;
  const delta = Date.now() - start;
  return delta >= 0 ? delta : null;
}

export function clearCheckoutTimer(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
